export const STATUS_LABEL_KEYS: Record<string, string> = {
  pending: 'accountOrders.status.pending',
  confirmed: 'accountOrders.status.confirmed',
  preparing: 'accountOrders.status.preparing',
  in_preparation: 'accountOrders.status.in_preparation',
  ready: 'accountOrders.status.ready',
  ready_for_pickup: 'accountOrders.status.ready_for_pickup',
  completed: 'accountOrders.status.completed',
  cancelled: 'accountOrders.status.cancelled',
};

export function getStatusLabel(status: string, t: (key: string) => string): string {
  const key = STATUS_LABEL_KEYS[status.toLowerCase()];
  return key ? t(key) : status;
}

// Legacy BubbleTeaOrder rows can have queue_number === null (nullable by
// design, see backend/app/db/models.py) -- never render the raw value
// directly via i18next interpolation, since it stringifies null to the
// literal word "null". Uses ?? (not ||) so a legitimate queue_number of 0
// is never mistaken for a missing value.
export function formatQueueNumberValue(
  queueNumber: number | null,
  notAvailableLabel: string
): string | number {
  return queueNumber ?? notAvailableLabel;
}
